
import HttpUtil from "@/assets/js/HttpUtil";
import { StoreTypes } from "@/assets/js/Types";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import box from "@/components/BoxCom.vue";
import rate from "@/components/Charts/RateCom.vue";
import mapCom from "@/components/MapCom.vue";
import Vue from "vue";
export default Vue.extend({
  components: { box, rate, mapCom },
  data() {
    return {
      map: null as any,
      detail: {} as any,
      currentSid: null as any,
      deviceList: [] as any,
      typeSid: null as any,
    };
  },
  mounted() {
    this.getTypeSid();
    this.getCurrentSid();
    this.map = this.$refs.map;
    this.map.init(true);
    this.initOnline();
    this.getDevice();
  },
  methods: {
    getTypeSid() {
      const path: any = this.$route.path;
      if (path.toLocaleLowerCase().indexOf("/home/dustcar") != -1) {
        this.typeSid = "c05";
      }
    },
    getCurrentSid() {
      const path: string = this.$route.path.toLocaleLowerCase();
      this.currentSid = Utils.getCurrentSid(path);
    },
    async getDevice() {
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceListByCSid,
        this.currentSid,
        true,
        false
      );
      if (this.typeSid == null) {
        this.deviceList = ret;
      } else {
        this.deviceList = ret.filter((x: any) => x.deviceTypeSid == this.typeSid);
      }
      this.map.addDeviceNew(this.deviceList, this.currentSid, null);
    },
    async initOnline() {
      const req: any = await HttpUtil.XCHttpPost(
        Urls.GetMapDeviceCountV2,
        { categorySid: this.currentSid, deviceTypeSid: this.typeSid },
        true,
        false
      );
      if (req && req.length == 1) {
        this.detail = req[0];
        const rate: any = this.$refs.rateOnline;
        rate.setAndInit(this.detail.deviceCount, this.detail.onlineCount, "在线率", 0);
        const rate2: any = this.$refs.rateOffline;
        rate2.setAndInit(this.detail.deviceCount, this.detail.offlineCount, "离线率", 1);
        const rate3: any = this.$refs.rateAlarm;
        rate3.setAndInit(this.detail.deviceCount, this.detail.alarmCount, "报警率", 2);
      }
    },
  },
});
